import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllProcurementTypesResponseModel, ProcurementTypeResponse } from '@gtpl/shared-models/procurement-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions, LoggerInstantiation } from 'apps/services/logger/logger-functions';
import { ProcurementTypesDto } from 'libs/shared-models/procurement-management/src/lib/procurement-types/procurement-types-dto';
import { Raw, Repository } from 'typeorm';
import { ProcurementTypeAdapter } from './dto/procurement-type.adapter';
import { ProcurementType } from './procurement-types.entity';
import { SpaceValidators } from '@gtpl/shared-utils/class-validators';
import { ProcurementTypeRequest } from './dto/procurement-type-request';



@Injectable()
export class ProcurementTypesService {
    constructor(
        @InjectRepository(ProcurementType) private procurementTypeRepository: Repository<ProcurementType>,
        private procurementTypeAdapter: ProcurementTypeAdapter,
      ) { }

      /**
     * It persists the sample type data
     * @param sampletype PpsSampleType object
     * @returns PpsSampleType object
     */
    @LogActions({isAsync: true})
    async saveProcurementType(procurementType: ProcurementTypesDto): Promise<ProcurementTypeResponse> {
        try {
            console.log('test');

            
            const procurementTypeCodeExists = await this.findProcurementType(procurementType.procurementType);
            if (procurementTypeCodeExists) {
                if (procurementTypeCodeExists.procurementType !== procurementType.procurementType) {
                    console.log('1');
                    throw new ErrorResponse(10104, 'procurement Type already exists');
                } else {
                    console.log('2');

                    if (!procurementTypeCodeExists.status) {
                    console.log('3');

                        throw new ErrorResponse(10117, 'You Cannot edit Deactivated Procurement Type');
                    }
                    if (procurementType.versionFlag !== procurementTypeCodeExists.versionFlag) {
                    console.log('4');

                        throw new ErrorResponse(10113, 'Someone updated the current Procurement Type information.Refresh and try again');
                    } else {
                    console.log('5');

                        procurementType.procurementType = procurementTypeCodeExists.procurementType;
                        procurementType.createdUser = procurementTypeCodeExists.createdUser;
                    }
                }
            } else {
                delete procurementType.updatedUser;
            }
            console.log('6');
            console.log(procurementType);

            const duplicatedprocurementType = JSON.parse(JSON.stringify(procurementType))
            // console.log(duplicatedprocurementType);
            const data: ProcurementType = await this.procurementTypeRepository.save(procurementType);
            console.log('7');

            const procurementTypeResponeseObj: ProcurementTypeResponse = new ProcurementTypeResponse(true, duplicatedprocurementType.procurementTypeId ? 10101 : 10100, duplicatedprocurementType.procurementTypeId ? 'Procurement Type updated successfully' : 'Procurement Type created successfully', data);
            return procurementTypeResponeseObj;
        } catch (error) {
            throw error;
        }
    }

      
    /**
     * gets all  procurement types details  
     * @returns all the procurement type details .
     */
  @LogActions({ isAsync: true })
  async getAllProcurementTypes(): Promise<AllProcurementTypesResponseModel> {  
    try {
      const procurementTypeDtos: ProcurementTypesDto[] = [];
      // retrieves all plants
      const procurementTypeEntities: ProcurementType[] = await this.procurementTypeRepository.find({
        order: { createdAt: "DESC" },
      });
      console.log(procurementTypeEntities);
      if (procurementTypeEntities.length>0) {
        procurementTypeEntities.forEach(procurementTypeEntity => {
          const convertedprocurementTypeDto: ProcurementTypesDto = this.procurementTypeAdapter.convertEntityToDto(procurementTypeEntity);
          procurementTypeDtos.push(convertedprocurementTypeDto);
        });
        const response = new AllProcurementTypesResponseModel(true, 11208, "Plants retrieved successfully", procurementTypeDtos);
        return response;
      } else {
          console.log('yest')
        throw new ErrorResponse(99998, 'No Records Found');
      }
    } catch (err) {
      throw err;
    }
  }

   /**
     * It deactivates procurement type 
     * @param procurementType procurement type  as string
     * @returns true or false
     */
    @LogActions({isAsync: true})
    async activateOrDeactivateProcurementeType(procurementType: ProcurementTypeRequest): Promise<ProcurementTypeResponse> {
        try {
            const sampletypeCodeExists = await this.findProcurementType(procurementType.procurementType);
            if (sampletypeCodeExists) {
                if (procurementType.versionFlag !== sampletypeCodeExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Sample Type information.Refresh and try again');
                } else {
                    // const config = {
                    //     headers: { Authorization: auth.authorization }
                    //   };
                    // const checksampleTypeUtilization = await this.additionalQuantityService.checkSampleTypeUtilization({ sampleType: procurementType.sampleTypeCode},config);

                    // // const sampleTypeAlreadyusedFlag: boolean = true;//true if not used in 
                    // if (checksampleTypeUtilization.status) {
                    //     throw new ErrorResponse(10116, 'Sample Type is Already Used In Additional quantity');
                    // } else {
                        const sampleTypeSatatus = await this.procurementTypeRepository.update({ procurementType: Raw(_alias => `UPPER(sample_type_code) = '${procurementType.procurementType.toLocaleUpperCase()}'`) }, { status: !sampletypeCodeExists.status, updatedUser: procurementType.updatedUser });
                        if (sampletypeCodeExists.status) {
                            if (sampleTypeSatatus.affected) {
                                const sampletypeGetObj: ProcurementTypeResponse = new ProcurementTypeResponse(true, 10115, 'procurement Type is de-activated successfully');
                                return sampletypeGetObj;
                            } else {
                                throw new ErrorResponse(10111, 'Procurement Type is already deactivated');
                            }
                        } else {
                            if (sampleTypeSatatus.affected) {
                                const sampletypeGetObj: ProcurementTypeResponse = new ProcurementTypeResponse(true, 10114, 'Procurement Type is activated successfully');
                                return sampletypeGetObj;
                            } else {
                                throw new ErrorResponse(10112, 'Sample Type is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

  /**
     * It gets procurement type data by procurement  type 
     * @param procurementType procurement Type  as string
     * @return PpsSampleType as object
     */
   @LogActions({isAsync: true})
   async findProcurementType(procurementType: string): Promise<ProcurementType> {
       try {
           return await this.procurementTypeRepository.findOne({ procurementType:'${procurementType}'});
       } catch (err) {
           throw err;
       }
   }
}
